import React from 'react';
import { View, Text, Pressable } from 'react-native';

import { Button } from 'app/src/elements/buttons';

const NoSaleModal = props => {
  const { saleAsset, updateSaleAsset, setShowModal, clearField } = props;

  const markNoSale = () => {
    updateSaleAsset({
      variables: {
        id: saleAsset.id,
        status: 'Not Sold',
      }
    });

    clearPrice();
  };

  const clearPrice = () => {
    clearField();
    setShowModal(false);
  };

  return (
    <View>
      <Text>Do you want to mark {saleAsset.lotNumber} as No Sale?</Text>
      <Button
        label="YES, mark as No Sale"
        onPress={markNoSale}
        wide
      />
      <Button
        label="No, just clear price"
        onPress={clearPrice}
        wide
      />
    </View>
  );
};

export default NoSaleModal;
